import React from 'react';
import '../css/AssignOkasboxes.css';
// import Icon from 'react-icons-kit';
// import { iosPlusEmpty } from 'react-icons-kit/ionicons';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import Modal from 'react-modal';
import _ from 'lodash';
import Cookies from 'js-cookie';
import AssignMemberLicenseModal from './AssignMemberLicenseModal';
import Sorting from './Sorting';
import SearchBar from './SearchBar';
import CheckboxMaterialUI from './CheckboxMaterialUI';
import CheckboxMaterialUIWhite from './CheckboxMaterialUIWhite';
import * as ActionTypes from '../actions/types';
import { connect } from 'react-redux';
import Loader from './Loader';
// import createHistory from 'history/createBrowserHistory';
import SnackBar from './SnackBar'

//Assign okas boxes page okas of okas box ai page
class AssignMemberLicense extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpenAssignOB: false,
      mlData: [],
      actualData: [],
      searchValue: '',
      assigningMemberLicense: [],
      addAnotherSuccess: '',
      loader: true,
      sortingStatus: {
        sortingName: '',
        defaultDown: true
      },
      snackbarActive: false,
      snackbarMessage: ''

    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalDelete = this.closeModalDelete.bind(this);
  }

  openModal() {
    this.setState({
      modalIsOpenAssignOB: false
    }, () => {
      this.setState({
        modalIsOpenAssignOB: true
      })
    })
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  closeModal() {
    this.setState({ modalIsOpenAssignOB: false });
  }

  closeModalDelete() {
    this.setState({
      modalIsOpenDelete: false
    });
  }


  ActivateAssignOBModel = (e) => {
    if (this.state.modalIsOpenAssignOB) {
      return <AssignMemberLicenseModal activeModal={true} assigningMemberLicense={this.state.assigningMemberLicense} successMessage={this.handleSuccess.bind(this)} />
    } else {
      return null
    }
  }

  handleSuccess = (e) => {
    if (e === 'addAnother') {
      let addAnotherSuccess = (
        <div className="row my-1">
          <div class="col-12 my-2 alert alert-success fade show" role="alert">
            {/* Successfully assigned Member License to System Integrator. */}
            {this.state.assigningMemberLicense > 1 ?
              "Successfully assigned Member License to Distributor." :
              "Successfully assigned Member Licenses to Distributor."
            }
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            </button>
          </div>
        </div>
      );
      this.setState({ addAnotherSuccess }, () => {
        setTimeout(() => {
          this.setState({
            addAnotherSuccess: ''
          })
        }, 3500)
      })
    }
    this.setState({
      modalIsOpenAssignOB: false,
      mlData: [],
      actualData: [],
      searchValue: '',
      assigningMemberLicense: [],
    }, () => this.fetchLicense())
  }

  componentDidMount() {
    this.fetchLicense();
    this.resetSearchBar()
  }

  fetchLicense = () => {
    this.setState({
      loader: true
    })
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/memberLicenseApi/', {
      method: "GET",
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({forceRefresh: true})
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        this.setState({
          mlData: data,
          actualData: data,
          loader: false
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }



  restoreData = (data) => {
    this.setState({
      mlData: data
    })
  }


  sortingFunc = (type, searchValue) => {
    if (type !== 'search') {
      if (this.state.sortingStatus.sortingName === type) {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: !this.state.sortingStatus.defaultDown
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.mlData.sort());
            // Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.mlData.sort());
          }
        })
      } else {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: true
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.mlData.sort());
            // Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.mlData.sort());
          }
        })
      }
    } else if (type === 'search') {
      type = 'search';
      Sorting(this.restoreData, type, this.state.actualData, searchValue);
    } else {
      type = 'reverse';
      Sorting(this.restoreData, type, this.state.actualData);
    }
  }


  fetchIconType = (e) => {
    if (e === this.state.sortingStatus.sortingName && this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-down pointer ml-2 float-right'
    } else if (e === this.state.sortingStatus.sortingName && !this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-up pointer ml-2 float-right'
    } else {
      return 'fas fa-chevron-down pointer ml-2 float-right icon-inactive'
    }
  }


  assignBoxCheckHandler = (okasBoxId, e) => {
    let assigningMemberLicense = this.state.assigningMemberLicense;
    if (e && okasBoxId !== 'all') {
      assigningMemberLicense.push(okasBoxId);
    } else if (e && okasBoxId === 'all') {
      assigningMemberLicense = [];
      this.state.mlData.forEach((firstElement) => {
        if (firstElement.status === "unassigned") {
          assigningMemberLicense.push(firstElement.id)
        }
      })
    } else if (!e && okasBoxId === 'all') {
      assigningMemberLicense = [];
    } else {
      _.pull(assigningMemberLicense, okasBoxId);
    }
    this.setState({ assigningMemberLicense })
  }

  checkStatusForAll = (okasBoxId) => {
    if (okasBoxId === 'all') {
      let allChecked = true;
      this.state.mlData.forEach((firstElement) => {
        if (firstElement.status === 'unassigned' && (_.indexOf(this.state.assigningMemberLicense, firstElement.id) === -1)) {
          allChecked = false;
        }
      })
      return allChecked;
    }
  }


  obDatatable = () => {
    if (this.state.mlData.length === 0) {
      return <tr style={{ textAlign: 'center' }} >No available member license</tr>
    }
    if (this.state.mlData !== null) {
      let someData = this.state.mlData.map((mlElement, index) => {
        if (mlElement.status === 'unassigned') {
          return <tr key={index} className="some-hover">
            <th scope="col" style={{ width: '5%' }} >
              <CheckboxMaterialUI
                changeHandler={this.assignBoxCheckHandler.bind(this, mlElement.id)}
                checkedStatus={_.indexOf(this.state.assigningMemberLicense, mlElement.id) !== -1}
              />
            </th>
            <td scope="col" style={{ width: '15%', verticalAlign: 'middle', fontSize:'12px' }}>{mlElement.id}</td>
            <td scope="col" style={{ width: '20%', verticalAlign: 'middle',  fontSize:'12px'}}>{mlElement.licenseNo}</td>
          </tr>
        }
      })
      return someData;
    } else {
      return null
    }
  }

  overlayShadowUnderModal = () => {
    if (this.state.modalIsOpenAssignOB) {
      return (
        <div style={{ position: 'absolute', height: `${window.innerHeight - 60}px`, width: `${window.innerWidth - 260}px`, backgroundColor: 'rgba(0,0,0,0.75)', zIndex: '0', display: '' }}></div>
      )
    } else {
      return null
    }
  }

  resetSearchBar = () => {
    this.props.searchBarActivate(false)
  }

  render() {
    return (
      <React.Fragment>
        <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
          this.setState({
            snackbarActive: false
          })
        }} message={this.state.snackbarMessage} />
        {this.state.loader ? <Loader /> : null}
        {this.overlayShadowUnderModal()}
        <div style={{ paddingLeft: '90px', paddingTop: '40px', paddingRight: '90px', height: `${window.innerHeight - 120}px` }}>
          {!this.props.redux.auth.searchBarShow ? <div style={{ marginBottom: '20px' }}>
            <span style={{ color: '#888888', fontSize: '30px', }}>ASSIGN MEMBER LICENSE</span>
            <span style={{ float: 'right' }}>
              {!this.props.redux.auth.searchBarShow ? <div className="row" style={{ margin: '0' }}>
                <div className="pointer" style={{ pointerEvents: this.state.assigningMemberLicense.length === 0 ? '' : '' }}
                  onClick={() => {
                    if (this.state.assigningMemberLicense.length === 0) {
                      this.setState({
                        snackbarActive: true,
                        snackbarMessage: 'Please select member license.'
                      })
                      // alert('Please select OKAS Box.')
                    } else {
                      this.openModal()
                    }
                  }
                  } >
                  <div className="buttonContent" style={{ backgroundColor: 'white', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)' }}>
                    {/* <Icon icon={iosPlusEmpty} size={40} style={{ color: "#F08100", backgroundColor: "none", }} /> */}
                    <IconButton sx={{
                      color: '#F08100',
                      fontSize: 40,
                      backgroundColor: 'transparent',
                      '&:hover': {
                        backgroundColor: 'transparent'
                      },
                      '&:focus': {
                        outline: 'none',
                        border: 'none',
                        backgroundColor: 'transparent'
                      }
                    }} aria-label="add">
                      <AddIcon sx={{ fontSize: 40 }} />
                    </IconButton>
                    <span style={{ color: '#888888', fontSize: '10px', fontWeight: '600' }}>SELECT DISTRIBUTOR</span>
                  </div>
                </div>
              </div> : null}
            </span>
          </div> : <div className='animated animated-duration-custom slideInDown pb-3 mt-2 flex-fill'>
            <SearchBar autoFocus
              value={this.state.searchValue}
              onChange={(e) => {
                this.setState({
                  searchValue: e
                }, () => {
                  this.sortingFunc('search', this.state.searchValue)
                })
              }
              }
              onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
              resetSearch={(e) => {
                this.setState({
                  searchValue: e
                }, () => {
                  this.sortingFunc('search', '')
                })
              }}
            /></div>}
          <div className="si-lisst col-s12">
            {this.state.addAnotherSuccess}
            <table className="table">
              <thead className="tableHeaderColor" style={{ borderRadius: '10px 10px 0px 0px' }}>
                <th scope="col" style={{ width: '5%' }}>
                  <CheckboxMaterialUIWhite
                    changeHandler={this.assignBoxCheckHandler.bind(this, 'all')}
                    checkedStatus={this.checkStatusForAll('all') && this.state.assigningMemberLicense.length !== 0}
                  />
                </th>
                <th scope="col" style={{ width: '15%', verticalAlign: 'middle', fontSize:'12px' }}>ID
                  <i class={this.fetchIconType('id')} onClick={(e) => { this.sortingFunc('id') }}></i>
                </th>
                <th scope="col" style={{ width: '20%', verticalAlign: 'middle', fontSize:'12px' }}>Member License
                  <i class={this.fetchIconType('licenseNo')} onClick={(e) => { this.sortingFunc('licenseNo') }}></i>
                </th>
              </thead>
              <tbody style={{ maxHeight: `${window.innerHeight - 280}px` }}>
                {this.obDatatable()}
              </tbody>
            </table>
          </div>
        </div>
        {this.ActivateAssignOBModel()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    redux: state,
  };
};


const mapDispatchToProps = dispatch => {
  return {
    searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(AssignMemberLicense);